import { render } from "./CouponDetail.vue?vue&type=template&id=31aa622a"
import script from "./CouponDetail.vue?vue&type=script&lang=js"
export * from "./CouponDetail.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__